import React from "react"
import PropTypes from "prop-types"
import MenuItem from "@mui/material/MenuItem"
import Link from "@mui/material/Link"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import menuItem from "./styles"

interface NotificationItemProps {
  icon: React.ReactNode
  title: string
  onClick?: () => void
}

const NotificationItem = React.forwardRef<HTMLLIElement, NotificationItemProps>(
  ({ icon, title, onClick, ...rest }, ref) => (
    <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
      <MDBox component={Link} py={0.5} display="flex" alignItems="center" lineHeight={1} onClick={onClick}>
        <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
          {icon}
        </MDTypography>
        <MDTypography variant="button" fontWeight="regular" sx={{ ml: 1 }}>
          {title}
        </MDTypography>
      </MDBox>
    </MenuItem>
  )
)

NotificationItem.displayName = "NotificationItem"

NotificationItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

export default NotificationItem
